import { render, staticRenderFns } from "./TravelFeatures.vue?vue&type=template&id=c5fad27a&"
import script from "./TravelFeatures.vue?vue&type=script&lang=ts&"
export * from "./TravelFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports